import { render } from "./ModalLoginRegister.vue?vue&type=template&id=642d54f0"
import script from "./ModalLoginRegister.vue?vue&type=script&lang=js"
export * from "./ModalLoginRegister.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__